"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _base = require("@mui/base");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _user = require("../../store/user");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _LogoS = _interopRequireDefault(require("../../assets/images/LogoS.png"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const App = () => {
  const {
    setIsLoading,
    setToastText,
    setToastOpen
  } = (0, _common.useCommonStore)();
  const {
    loginEmail,
    loginPassword,
    errors,
    logining,
    login,
    setLoginEmail,
    setLoginPassword
  } = (0, _user.useUserStore)(); //  const [loginEmail, setLoginEmail] = React.useState('');
  //  const [loginPassword, setLoginPassword] = React.useState('');
  const [, setLocation] = (0, _wouter.useLocation)();
  const emailRef = _react.default.useRef(null);
  const passwordRef = _react.default.useRef(null);
  const submitRef = _react.default.useRef(null);
  const resetRef = _react.default.useRef(null);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...stylex.props(_Style.wrapper.fill, _Style.wrapper.center),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "column",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      rowSpacing: 6,
      sx: {
        height: '100vh',
        width: '33vw'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        ...stylex.props(_Style.textStyle.h1),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          ...stylex.props(_Style.imageStyle.logo),
          src: _LogoS.default,
          alt: "Justudy"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        container: true,
        direction: "column",
        rowSpacing: 2,
        size: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
          container: true,
          direction: "column",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            spacing: 0,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
              label: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
              ref: emailRef,
              type: "string",
              value: loginEmail,
              errorText: errors.loginEmail,
              placeholder: 'メールアドレスを入力してください)',
              onChange: event => {
                setLoginEmail(event.target.value);
              },
              onEnterKey: () => {
                var _passwordRef$current;
                (_passwordRef$current = passwordRef.current) === null || _passwordRef$current === void 0 ? void 0 : _passwordRef$current.focus();
              }
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            container: true,
            direction: "column",
            spacing: 1,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
              container: true,
              direction: 'column',
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
                label: "\u30D1\u30B9\u30EF\u30FC\u30C9",
                ref: passwordRef,
                type: "password",
                value: loginPassword,
                errorText: errors.newPassword,
                placeholder: 'パスワードを入力してください)',
                onChange: event => {
                  setLoginPassword(event.target.value);
                },
                onEnterKey: () => {
                  var _submitRef$current;
                  (_submitRef$current = submitRef.current) === null || _submitRef$current === void 0 ? void 0 : _submitRef$current.focus();
                }
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
            container: true,
            direction: "column",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
              ...stylex.props(_Style.textStyle.p1b, _Style.buttonStyle.primary),
              disabled: logining || !loginEmail || !loginPassword,
              ref: submitRef,
              onClick: async () => {
                setIsLoading(true);
                const {
                  isSuccess
                } = await login();
                if (!isSuccess) {
                  setToastText("ログインできませんでした。メールアドレスとパスワードの組み合わせを再度ご確認ください");
                  setToastOpen(true);
                  setIsLoading(false);
                  return;
                }
              },
              children: logining ? 'ログインしています...' : 'ログイン'
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_base.Button, {
              ...stylex.props(_Style.textStyle.p1b, _Style.buttonStyle.secondary),
              ref: resetRef,
              onClick: async () => {
                setToastText("サンプルではこの機能は使えません");
                setToastOpen(true);
                return;
                setLocation('/send-reset-password');
              },
              children: 'パスワードを忘れた方はコチラ'
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
            minHeight: 48,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              ...stylex.props(_Style.textStyle.error),
              children: errors.login
            })
          })]
        })
      })]
    })
  });
};
var _default = exports.default = App;